type VariantLike = { id?: string; availableForSale?: boolean };
type NodeLike = { variants?: { edges?: Array<{ node: VariantLike }> } } | null | undefined;

/** True only when Shopify explicitly reports the variant (or first variant) as not for sale. */
export function isSoldOut(node: NodeLike, variantId?: string): boolean {
  const edges = node?.variants?.edges ?? [];
  const v = (variantId ? edges.find((e) => e.node.id === variantId)?.node : undefined) ?? edges[0]?.node;
  return v?.availableForSale === false;
}
